export default "__VITE_ASSET__4db4ae61__"